export default "__VITE_ASSET__ChMJotEq__"